import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { of } from 'rxjs';
import { GET_RELEASES } from './release.response.object';

@Injectable({
  providedIn: 'root',
})
export class ReleaseApi {
  protected readonly httpClient = inject(HttpClient);

  public getReleases() {
    return of(GET_RELEASES);
    //return this.httpClient.get<ReleaseContract[]>('releases');
  }
}
